/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { __decorate } from "tslib";
import { attachShadowTemplate, CustomElement } from '@tylertech/forge-core';
import { BaseComponent } from '../core/base/base-component';
import { DIVIDER_CONSTANTS } from './divider-constants';
const template = '<template><div class=\"forge-divider\" role=\"separator\" part=\"root\"></div></template>';
const styles = '.forge-divider{border:none;border-bottom-color:#e0e0e0;border-bottom-color:var(--forge-theme-border-color,#e0e0e0);border-bottom-width:1px;border-bottom-width:var(--forge-divider-width,1px);margin:0;margin:var(--forge-divider-margin,0);height:0;border-bottom-style:solid}:host{display:block;contain:content}:host([hidden]){display:none}:host-context(forge-drawer) .forge-divider{margin:var(--forge-divider-drawer-margin,4px) 0}:host([vertical]){display:inline-block;height:100%}:host([vertical]) .forge-divider{border:none;border-right-color:#e0e0e0;border-right-color:var(--forge-theme-border-color,#e0e0e0);border-right-width:1px;border-right-width:var(--forge-divider-width,1px);margin:0;margin:var(--forge-divider-margin,0);height:100%;width:0;border-right-style:solid}';
/**
 * The custom element class behind the `<forge-divider>` element.
 *
 * @tag forge-divider
 */
let DividerComponent = class DividerComponent extends BaseComponent {
    constructor() {
        super();
        attachShadowTemplate(this, template, styles);
    }
};
DividerComponent = __decorate([
    CustomElement({
        name: DIVIDER_CONSTANTS.elementName
    })
], DividerComponent);
export { DividerComponent };
